export const BORDER_RADIUS = 1;
export const CARET_SIDE_SIZE = 8;

export const popableStyles = {
  container: {
    position: 'relative',
    zIndex: 1,
  } as React.CSSProperties,
  popoverTop: {
    bottom: '100%',
  } as React.CSSProperties,
  popoverBottom: {
    top: '100%',
  } as React.CSSProperties,
  popoverCaretLeft: {
    left: 0,
    transform: [{translateX: 0}],
  },
  popoverCaretRight: {
    right: 0,
    transform: [{translateX: 1}],
  },
};

export const popoverStyles = {
  container: {
    width: 100,
  } as React.CSSProperties,
  containerHorizontal: {
    flexDirection: 'row',
  } as React.CSSProperties,
  content: {
    flex: 1,
    zIndex: 1,
    borderRadius: 4,
    overflow: 'hidden',
    padding: 8,
  } as React.CSSProperties,
  contentTextOnly: {
    padding: 6,
  } as React.CSSProperties,

  caret: {
    zIndex: 0,
  } as React.CSSProperties,
};

export const backDropStyles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000,
  } as React.CSSProperties,
  modalContent: {
    backgroundColor: 'transparent',
    borderRadius: '8px',
    height: '100%',
    position: 'absolute',
    width: '100%',
    overflow: 'visible',
  } as React.CSSProperties,
};

export const caretStyles = {
  container: {
    width: CARET_SIDE_SIZE,
    height: CARET_SIDE_SIZE,
    transform: `rotate(45deg)`,
    borderRadius: BORDER_RADIUS,
  },
  containerPositionTop: {
    marginBottom: 8,
  },
  containerPositionBottom: {
    marginTop: 8,
  },
  containerPositionLeft: {
    marginRight: 8,
  },
  containerPositionRight: {
    marginLeft: 8,
  },
  containerCenter: {
    alignSelf: 'center',
  } as React.CSSProperties,
  containerRight: {
    alignSelf: 'flex-end',
  } as React.CSSProperties,
};
